import DocumentsTabContainer from './DocumentsTabContainer';

export default DocumentsTabContainer;
